var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBurgerR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5H23C23.5523 5 24 4.55228 24 4C24 3.44772 23.5523 3 23 3Z",
  fill: "#003399"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 11H1C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11Z",
  fill: "#003399"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 19H1C0.447715 19 0 19.4477 0 20C0 20.5523 0.447715 21 1 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19Z",
  fill: "#003399"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBurgerR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/burger-r.0b091b146919eeb553066b07b893cc8b.svg";